import Env from '../base/env';
import { module } from 'modujs';
import { RevealFade } from '../fx/Common';
import gsap from 'gsap';

export default class extends module {
  constructor(m) {
    super(m);
  }
  init() {
    this.DOM = {};
    this.DOM.view = this.el;

    //? Fns
    gsap.delayedCall(Env.timingDelayFx, () => {
      RevealFade(this.DOM.view);
    });
  }
}
